export default __webpack_public_path__ + "static/media/verified.bdfb77e1.svg";